import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { verifyEmailApi } from '../api';
import './Auth.css';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { completeVerification } = useAuth();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token.');
      return;
    }
    let active = true;
    (async () => {
      try {
        const data = await verifyEmailApi(token);
        if (!active) return;
        await completeVerification({ token: data.token, user: data.user });
        setStatus('success');
        setTimeout(() => navigate('/portal'), 1200);
      } catch (err) {
        if (!active) return;
        setStatus('error');
        setMessage(err?.detail || 'This verification link is invalid or has already been used.');
      }
    })();
    return () => { active = false; };
  }, [params, navigate, completeVerification]);

  return (
    <div className="auth-page">
      <div className="auth-left">
        <img
          src="https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=1200&q=80"
          alt=""
          className="auth-bg-image"
        />
        <div className="auth-left-overlay" />
        <div className="auth-left-content">
          <span className="auth-left-wordmark">AEGENT</span>
          <h2 className="auth-left-headline">Build systems<br />that think.</h2>
        </div>
      </div>
      <div className="auth-right">
        <div className="auth-form-container">
          <div className="auth-form-header">
            <h1 className="t-caption">
              {status === 'verifying' && 'Verifying…'}
              {status === 'success' && 'Email verified'}
              {status === 'error' && 'Verification failed'}
            </h1>
          </div>
          <p style={{ fontSize: 13, color: 'var(--fg-muted)', marginBottom: 24, lineHeight: 1.5 }}>
            {status === 'verifying' && 'Confirming your email address…'}
            {status === 'success' && 'Your email is verified. Redirecting you to the portal…'}
            {status === 'error' && message}
          </p>
          {status === 'error' && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => navigate('/auth')}
              style={{ width: '100%' }}
            >
              Back to sign in
            </button>
          )}
        </div>
        <div className="auth-footer-brand">
          <span>AEGENT by akakAI</span>
        </div>
      </div>
    </div>
  );
}
